import { useContext } from "react";
import { BsArrowRight } from "react-icons/bs";
import { Container } from "../..";
import heroImage from "../../../assets/img/hero.png";
import { Form } from "../../Form/index";
import { Tilt } from "../../Tilt";
import { ThemeContext } from "../../context";
import {
  JiffyContent,
  JiffyHeroContainer,
  JiffyImage,
  JiffyImageContainer,
  JiffyLogistics,
  JiffyLogisticsContent,
  WelcomeJiffy,
} from "./Hero.elements";

export const Hero = () => {
  const entries = [
    {
      id: 1,
      type: "email",
      placeholder: "Enter Email Address",
      typePlaceholder: "Select type",
    },
  ];

  const { rooTheme } = useContext(ThemeContext);
  return (
    <Container>
      <JiffyHeroContainer rooTheme={rooTheme}>
        <JiffyContent>
          <WelcomeJiffy>Welcome to Jiffy’s world</WelcomeJiffy>
          <JiffyLogistics rooTheme={rooTheme}>
            Logistics Gateway for your Sendables
          </JiffyLogistics>
          <JiffyLogisticsContent rooTheme={rooTheme}>
            {/* End-to-End technology-enabled logistics solutions for businesses and individuals for logistics delight

            all-in-1 solution to easily manage deliveries with live tracking, automated dispatch, proof of delivery, reviews and more. */}
            All-in-1 logistics solution to deliver, with live tracking,
            automated dispatch, proof of delivery, reviews and so much more.
          </JiffyLogisticsContent>
          <Form opacity={1} entries={entries} icon={<BsArrowRight />} />
        </JiffyContent>

        <JiffyImageContainer>
          <Tilt>
            <JiffyImage src={heroImage} alt="jiggy hero" />
          </Tilt>
        </JiffyImageContainer>
      </JiffyHeroContainer>
    </Container>
  );
};
